import * as React from 'react';
import { SelectCore, } from '@core-front/select';
import Check from '@telia-front/check';
import FormHelper from '@telia-front/form-helper';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
class Select extends React.Component {
    static isValueArray(value) {
        return Array.isArray(value);
    }
    render() {
        return (React.createElement(SelectCore, Object.assign({}, this.props, { components: {
                Check,
                FormHelper,
                Icon,
                Image,
            } })));
    }
}
Select.defaultProps = {
    live: false,
    placeholder: '',
    simpleValue: false,
};
export default Select;
